<template>
  <main-container style="overflow: hidden">
    <router-view />
  </main-container>
</template>

<script>
import { defineComponent } from "vue";
import MainContainer from "@/app/shared/components/organisms/MainContainer.vue";

export default defineComponent({
  components: {
    MainContainer,
  },
  unmounted() {
    this.$store.dispatch("setSelectedEntity", 0);
    this.$store.dispatch("setSelectedPortfolio", 0);
    this.$store.commit("SET_PORTFOLIOS", {
      pagination: {},
      items: [],
    });
  },
});
</script>
